import { Badge, CircleImage, CircleImageContent } from "olive-react-myoneui";

const NameTemplate = ({ value, data, tableManager }) => {
    const {
      config: {
        additionalProps: { cell: additionalProps = {} },
      },
    } = tableManager;
  
    const classNames = ('rgt-cell-inner rgt-text-truncate ' + (additionalProps.className || '')).trim();
  
    return (
      <div {...additionalProps} className={classNames} title={value}>
        <div className="d-flex gap-2 align-items-center overflow-hidden">
          <CircleImage className="circle-wrap circle-wrap-md">
            {/* <CircleImageContent svgImage="two" /> */}
            <img src={data?.imageUrl} />
          </CircleImage>
          <span className="grid-text-overflow ">{value}</span>
          {data.isNew && <Badge className="badge blue badge-round">New</Badge>}
        </div>
      </div>
    );
  };
  export default NameTemplate;